import { DefaultButton, IButtonProps, Icon, Link } from "@fluentui/react";
import { css, useTheme } from "cayo.ui";
import React, { CSSProperties, FC } from "react";

const ConfigureButton: FC<
  {
    icon: string;
    text: string;
    onClick: () => void;
    completed?: boolean;
    width: number;
    helpLink: string;
    style?: CSSProperties;
  } & IButtonProps
> = ({ icon, text, onClick, width, style, helpLink, disabled }) => {
  const { cayoTheme } = useTheme();
  return (
    <div className={css.relative}>
      <DefaultButton
        toggle={true}
        onClick={onClick}
        disabled={disabled}
        styles={{
          root: {
            position: "relative",
            width,
            height: width,
            fontSize: 12,
            padding: 0,
            ...(style as {}),
          },
          flexContainer: { flexFlow: "column", justifyContent: "space-evenly" },
          textContainer: { flexGrow: 0 },
          rootHovered: { color: cayoTheme.brandColors.primaryHighlight },
        }}
      >
        <Icon iconName={icon} styles={{ root: { fontSize: 56 } }} />
        <span className={css.preLine}>{text}</span>
      </DefaultButton>
      {helpLink && (
        <Link
          target="_blank"
          href={helpLink}
          onMouseDown={(e) => e.stopPropagation()}
          styles={{
            root: {
              position: "absolute",
              right: 8,
              top: 8,
            },
          }}
        >
          <Icon
            iconName="Unknown"
            styles={{
              root: {
                fontSize: 16,
                color: cayoTheme.brandColors.disabled,
              },
            }}
          />
        </Link>
      )}
    </div>
  );
};

export default ConfigureButton;
